export default {
  Clipboard: {
    mounted() {
      this.el.addEventListener('click', async e => {
        try {
          await navigator.clipboard.writeText(this.el.dataset.clipboardContent);

          // Add visual feedback animation
          this.el.classList.add('clipboard-copied');
          setTimeout(() => {
            this.el.classList.remove('clipboard-copied');
          }, 300);

          // Show toast notification
          this.showToast('Copied!');
        } catch (err) {
          console.error('Failed to copy to clipboard:', err);
        }
      });
    },

    showToast(message) {
      // Create toast element matching flash notification design
      const toast = document.createElement('div');
      toast.className = 'clipboard-toast';
      toast.setAttribute('role', 'alert');

      // Create inner structure matching flash component
      const content = document.createElement('div');
      content.className = 'flex items-start';

      // Icon container
      const iconContainer = document.createElement('div');
      iconContainer.className = 'shrink-0';
      const icon = document.createElement('span');
      icon.className = 'hero-check-circle-mini h-4 w-4 text-green-600';
      iconContainer.appendChild(icon);

      // Text container
      const textContainer = document.createElement('div');
      textContainer.className = 'ml-3 w-0 flex-1 pt-0.5';
      const text = document.createElement('p');
      text.className = 'text-gray-900';
      text.textContent = message;
      textContainer.appendChild(text);

      content.appendChild(iconContainer);
      content.appendChild(textContainer);
      toast.appendChild(content);

      document.body.appendChild(toast);

      // Trigger animation
      setTimeout(() => toast.classList.add('show'), 10);

      // Remove after animation
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
          if (document.body.contains(toast)) {
            document.body.removeChild(toast);
          }
        }, 300);
      }, 2000);
    },
  },
};
